import Vue from 'vue'
import $storage from './storage'
import $file from './file'
import $opener from './windowOpener'

Vue.prototype.$storage = $storage;
Vue.prototype.$file = $file;
Vue.prototype.$config = {
    apiUrl: process.env.API_URL
}
Vue.prototype.$opener = $opener

Vue.mixin({
    methods: {
    }
})